import { Container } from "react-bootstrap";
import AI from "../../../images/home/statistics.svg";
import mobileDevelopment from "../../../images/home/project.svg";
import devops from "../../../images/home/coding-develop.svg";
import UI from "../../../images/home/shortlist.svg";

const Solutions = () => {

    return (
        <>
            <section className="solutions-section">
                <Container fluid>
                    <div className="text-center mb-4">
                        <h2 className="ft-wt-700 text-uppercase text-white">We Understand Your Challenges</h2>
                    </div>
                    <div className="contents-wrapper">
                        <div className="content-item text-start">
                            <img src={AI} alt="artificial intelligence" loading="lazy" />
                            <div className="contents">
                                <div className="contents-title">
                                    <h5 className="ft-wt-600 text-uppercase text-white mb-4">Increase Revenue</h5>
                                </div>
                                <div className="contents-description">
                                    <h5 className="ft-wt-600 text-capitalize text-white">Our team members are flexible with start and end times to match our client time zones, from the USA all the way to Australia.</h5>
                                </div>
                            </div>
                        </div>
                        <div className="content-item text-start">
                            <img src={mobileDevelopment} alt="mobile development" loading="lazy" />
                            <div className="contents">
                                <div className="contents-title">
                                    <h5 className="ft-wt-600 text-uppercase text-white mb-4">The outcome does not mee the project brief?</h5>
                                </div>
                                <div className="content-description">
                                    <h5 className="ft-wt-600 text-capitalize text-white">We have sophisticated project management procedures at different stages to ensure we align with the client brief and expectations.</h5>
                                </div>
                            </div>
                        </div>
                        <div className="content-item text-start">
                            <img src={devops} alt="devops" loading="lazy" />
                            <div className="contents">
                                <div className="contents-title">
                                    <h5 className="ft-wt-600 text-uppercase text-white mb-4">Unresponsive offshore development team?</h5>
                                </div>
                                <div className="content-description">
                                    <h5 className="ft-wt-600 text-capitalize text-white">Our team is experienced with being on call for high demand software applications where short response time is critical. We’re made of developers who have strong technical expertise you can rely on.</h5>
                                </div>
                            </div>
                        </div>
                        <div className="content-item text-start">
                            <img src={UI} alt="ui" loading="lazy" />
                            <div className="contents">
                                <div className="contents-title">
                                    <h5 className="ft-wt-600 text-uppercase text-white mb-4">Hired the wrong developer for your project previously?</h5>
                                </div>
                                <div className="content-description">
                                    <h5 className="ft-wt-600 text-capitalize text-white">In the Acube process, you get select from a pool of highly skilled and experienced developers.</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </Container >
            </section >
        </>
    )
};

export default Solutions